import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';
import imageCompression from 'browser-image-compression';
import Aux from '../utils/AuxFunctions'

var firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: "richless.app",
    databaseURL: "https://richless-20757.firebaseio.com",
    projectId: "richless-20757",
    storageBucket: "richless-20757.appspot.com",
    messagingSenderId: "186762442840",
    appId: "1:186762442840:web:7f58f4874e26e0c990322d",
    measurementId: "G-VMV0NBX4BF"
};

// Initialize Firebase
//firebase.initializeApp(firebaseConfig);
const TYPE_BUY_COINS = 1;
const TYPE_CREATE_POST = 2;
const TYPE_COMMENTED = 3;
const TYPE_MESSAGE_SENT = 4;
const TYPE_MESSAGE_RECEIVED = 5;
const TYPE_LINK_ACCEPTED = 6;
const TYPE_LINK_USED = 7;

//const TYPE_SYSTEM_SENT = 8;
const TYPE_SYSTEM_RECEIVED = 9;



const TYPE_ACHIEVEMENT = 12;
const TYPE_DAILY_REWARD = 13;

const TYPE_SEND_REQUEST_MESSAGE = 14

const TYPE_COMMENT_REWARD = 15

const TYPE_LIKES_REWARD = 16

const TYPE_ADD_COLLECTABLE = 17
//const TYPE_BUY_COLLECTABLE = 18

const REWARD_LINK = 10;
const REWARD_LINK_USED = 10;

const LIMIT_TRENDING_REWARD = 20;
class Fire {

    constructor() {
        this.socialCredentials = {}
        this.currentUser = {}
        this.dummyUid = ""
        try {
            firebase.initializeApp(firebaseConfig);
        } catch (error) {
            Aux.handleError(error)
        }
    }

    get uid() {
        if(this.dummyUid){
            return this.dummyUid
        }else if (firebase.auth().currentUser) {
            return firebase.auth().currentUser.uid
        } else {
            return ""
        }
    }

    get user() {
        return this.currentUser || { username: "unknown", coins: 0 };
    }

    get isDummy() {
        return this.dummyUid !== ""
    }

    get firebase() {
        return firebase;
    }

    get timestamp() {
        return firebase.firestore.FieldValue.serverTimestamp();
    }

    get firestore() {
        return firebase.firestore();
    }

    decrementValue(coins) {
        if (coins)
            return firebase.firestore.FieldValue.increment(-coins);
        else
            return firebase.firestore.FieldValue.increment(-1);
    }

    incrementValue(coins) {
        if (coins)
            return firebase.firestore.FieldValue.increment(coins);
        else
            return firebase.firestore.FieldValue.increment(1);
    }

    checkAuthStatus() {
        return new Promise((resolve, reject) => {
            try {
                firebase.auth().onAuthStateChanged(user => resolve(user))
            } catch (err) {
                reject(err)
            }
        })
    }

    loginFacebook = async () => {
        try {
            var provider = new firebase.auth.FacebookAuthProvider();
            provider.addScope('email');
            var newUser = {}
            await firebase.auth().signInWithPopup(provider).then((result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                //var token = result.credential.accessToken;

                this.socialCredentials = result.user;
                this.socialCredentials.provider = "facebook";
                newUser = result
            }).catch((error) => {
                Aux.handleError(error)
                newUser = "error";
            });
            return newUser
        } catch (error) {
            Aux.handleError(error)
        }
    }

    loginGoogle = async () => {
        try {
            var provider = new firebase.auth.GoogleAuthProvider();
            //provider.addScope('email');

            await firebase.auth().signInWithPopup(provider).then( (result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                //var token = result.credential.accessToken;
                // The signed-in user info.
                //var user = result.user;
                this.socialCredentials = result.user;
                this.socialCredentials.provider = "google";
                return result
                // ...
            })
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getUserData = async (uid) => {
        try {
            let userQuery = await firebase.firestore().collection("users").doc(uid ? uid : this.uid).get();
            if (userQuery.exists) {
                if (userQuery.data().username !== "") {
                    this.currentUser = userQuery.data()
                    this.currentUser.uid = this.uid
                    return userQuery.data()
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } catch (error) {
            Aux.handleError(error)
            throw error
        }
    }

    loginUser = async (email, password) => {
        try {
            await firebase.auth().signInWithEmailAndPassword(email, password)
            return await this.getUserData()
        } catch (error) {
            Aux.handleError(error)
            throw error
        }

    }

    CreateMyLink = async (uid) => {
        try {
            const link = await this.CreateShortLink(uid)
            let db = firebase.firestore().collection("users").doc(this.uid)
            await db.update({
                linkId: link,
            })
        } catch (error) {
            Aux.handleError(error)
        }
    }

    acceptPending = async (id, type, coins, senderuid, message) => {
        try {
            const userDocument = firebase.firestore().collection('users').doc(this.uid)
            //const messagesDoc = userDocument.collection('messages')
            const balanceDocument = userDocument.collection('balance').doc();
            const activitiesDoc = userDocument.collection('activity').doc(id)
            var batch = firebase.firestore().batch();

            if (type === "message") {
                batch.update(activitiesDoc, {
                    state: "accepted"
                })
                batch.set(balanceDocument, {
                    type: TYPE_MESSAGE_RECEIVED,
                    amount: coins,
                    message: message || "",
                    timestamp: this.timestamp,
                    uid: senderuid,
                })

            } else if (type === "referral_reward" || type === "referral_used") {

                batch.update(activitiesDoc, {
                    state: "accepted"
                })
                batch.set(balanceDocument, {
                    type: type === "referral_reward" ? TYPE_LINK_ACCEPTED : TYPE_LINK_USED,
                    amount: coins,
                    timestamp: this.timestamp,
                    uid: senderuid,
                })
            } else if (type === "system_message") {
                batch.update(activitiesDoc, {
                    state: "accepted"
                })
                batch.set(balanceDocument, {
                    type: TYPE_SYSTEM_RECEIVED,
                    amount: coins,
                    timestamp: this.timestamp,
                    uid: senderuid,
                })
            } else if(type === "comment"){
                batch.update(activitiesDoc, {
                    state: "accepted"
                })
                batch.set(balanceDocument, {
                    type: TYPE_COMMENT_REWARD,
                    amount: coins,
                    message: message || "",
                    timestamp: this.timestamp,
                    uid: senderuid,
                })
            }
            batch.update(userDocument, { coins: firebase.firestore.FieldValue.increment(coins) })
            await batch.commit()
            return true;
        } catch (error) {
            Aux.handleError(error)
            return false;
        }
    }

    claimRewardAchivement = async (id, reward) => {
        const userDocument = firebase.firestore().collection("users").doc(this.uid);
        const balanceDocument = userDocument.collection("balance").doc();
        const userStatistics = userDocument.collection("statistics").doc("statistics")
        var batch = firebase.firestore().batch();
        try {
            batch.update(userDocument, {
                coins: this.incrementValue(reward)
            })
            if(id !== 0){
                batch.update(userStatistics, {
                    [id]: true
                })
                batch.set(balanceDocument, {
                    type: TYPE_ACHIEVEMENT,
                    amount: reward,
                    timestamp: this.timestamp,
                    achievement: id,
                })
            }else{
                batch.update(userStatistics, {
                    likesToEarn: this.decrementValue(10),
                    likesEarned: this.incrementValue(),
                })
                batch.set(balanceDocument, {
                    type: TYPE_LIKES_REWARD,
                    amount: reward,
                    timestamp: this.timestamp,
                    achievement: id,
                })

            }
            
            
            //await firestore().collection("users").doc(this.uid).update({coins: firestore.FieldValue.increment(coinsToAdd)})
            await batch.commit()
            return true
        } catch (error) {
            Aux.handleError(error)
            return false
        }
    }

    claimDailyReward = async (day, reward, isLastDay) => {
        const userDocument = firebase.firestore().collection("users").doc(this.uid);
        const balanceDocument = userDocument.collection("balance").doc();
        const userStatistics = userDocument.collection("statistics").doc("statistics")
        var batch = firebase.firestore().batch();
        try {
            batch.update(userDocument, {
                coins: this.incrementValue(reward),
                lastDayReward: isLastDay ? 1 : day,
                lastTimestamp: this.timestamp
            })
            batch.update(userStatistics, {
                totalDailyReward: this.incrementValue(reward),
                totalDailyDays: this.incrementValue()
            })
            batch.set(balanceDocument, {
                type: TYPE_DAILY_REWARD,
                amount: reward,
                timestamp: this.timestamp,
                day: day,
            })

            await batch.commit()
            return true
        } catch (error) {
            Aux.handleError(error)
            return false
        }
    }

    reauthenticate = async (currentPassword) => {
        try {
            var user = firebase.auth().currentUser;

            /* var cred =  firebase.auth.EmailAuthProvider.credential(
                user.email, currentPassword); */

            var cred = firebase.auth.EmailAuthProvider.credential(user.email, currentPassword);

            /*switch(this.currentUser.provider){
              case "email":
                  cred =  await firebase.auth.EmailAuthProvider.credential(user.email, currentPassword);
                  break;
             case "facebook":
                  const data = await AccessToken.getCurrentAccessToken();
                  if (!data) {
                      // handle this however suites the flow of your app
                      throw new Error('Something went wrong obtaining the users access token');
                  }
                   cred = firebase.auth.FacebookAuthProvider.credential(data.accessToken);
                  break;
              case "google":
                   GoogleSignin.configure({
                      //webClientId: '511316647984-g6krgdg71i4k25so9q05723ofpqib5b6.apps.googleusercontent.com'
                      webClientId: '186762442840-pjc0pemgfqkq5nfhdmq2d6bhpstnj0qh.apps.googleusercontent.com'
                  });
                  const dataGoogle = await GoogleSignin.getTokens();
                  if (!dataGoogle) {
                      // handle this however suites the flow of your app
                      throw new Error('Something went wrong obtaining the users access token');
                  }
                  // create a new firebase credential with the token
                  cred = await firebase.auth.GoogleAuthProvider.credential(dataGoogle.idToken, dataGoogle.accessToken)
                  break; 
              default: 
                  break;
          }*/

            var auth = await user.reauthenticateWithCredential(cred)
            return auth;
        } catch (error) {
            Aux.handleError(error)
            return error
        }
    }

    changePassword = async (newPassword) => {
        try {
            var user = firebase.auth().currentUser;
            await user.updatePassword(newPassword)
            return "sucess";
        } catch (error) {
            Aux.handleError(error)
            return error
        }
    }

    changeEmail = async (newEmail) => {
        try {
            var user = firebase.auth().currentUser;
            await user.updateEmail(newEmail)
            await firebase.firestore().collection("users").doc(this.uid).update({ email: newEmail })
            return "sucess";
        } catch (error) {
            Aux.handleError(error)
            return error
        }
    }

    deleteAccount = async () => {
        try {
            const userDoc = firebase.firestore().collection('users').doc(this.uid)
            var batch = firebase.firestore().batch();
            const query = await firebase.firestore().collection("posts").where("uid", "==", this.uid).get();
            query.forEach(doc => {
                batch.update(doc.ref, {
                    hide: true
                })
            })
            const commentQuery = await firebase.firestore().collection("comments").where("uid", "==", this.uid).get();
            commentQuery.forEach(doc => {
                batch.update(doc.ref, {
                    hide: true
                })
            })
            batch.delete(userDoc)

            await batch.commit().then(() => {
                var del = firebase.auth().currentUser;
                del.delete();
            })
            return true;
        } catch (error) {
            Aux.handleError(error)
            return false
        }
    }

    InitialReferralLinkUid = async (uid) => {
        if (!uid || uid === "") {
            return;
        }
        try {
            const targetDoc = await firebase.firestore().collection("users").doc(uid).get();
            if (targetDoc.exists) {
                const userDocument = firebase.firestore().collection('users').doc(this.uid)
                const targetUserActivity = firebase.firestore().collection('users').doc(uid).collection('activity')
                const targetUserStatistics = firebase.firestore().collection('users').doc(uid).collection('statistics').doc("statistics")
                const userActivity = firebase.firestore().collection('users').doc(this.uid).collection('activity')
                var batch = firebase.firestore().batch();
                batch.set(targetUserStatistics, { referralCount: this.incrementValue(), referralCoinsTotal: this.incrementValue(REWARD_LINK_USED) }, { merge: true })
                batch.set(targetUserActivity.doc(),
                    {
                        timestamp: this.timestamp,
                        //text: message, 
                        state: "pending",
                        type: "referral_used",
                        uid: this.uid,
                        coins: REWARD_LINK_USED,
                    })
                batch.set(userActivity.doc(),
                    {
                        timestamp: this.timestamp,
                        //text: message, 
                        state: "pending",
                        type: "referral_reward",
                        uid: uid,
                        coins: REWARD_LINK,
                    })

                batch.update(userDocument, { referralUser: uid, })

                await batch.commit()
                return true;
            } else {
                return false
            }
        } catch (error) {
            Aux.handleError(error)
            return false
        }
    }

    addCoinsWithReceipt = async (coinsToAdd, receipt) => {
        const userDocument = firebase.firestore()
            .collection("users")
            .doc(this.uid);
        const balanceDocument = userDocument.collection("balance").doc();
        var batch = firebase.firestore().batch();
        try {
            batch.update(userDocument, {
                coins: this.incrementValue(coinsToAdd)
            })
            batch.set(balanceDocument, {
                type: TYPE_BUY_COINS,
                amount: coinsToAdd,
                timestamp: this.timestamp,
                receipt: receipt,
            })
            //await firestore().collection("users").doc(this.uid).update({coins: firestore.FieldValue.increment(coinsToAdd)})
            await batch.commit()
            return true
        } catch (error) {
            Aux.handleError(error)
            return false;
        }
    }

    submitReferralLinkUsername = async (username) => {
        try {

            let userRef = "";
            const targetDoc = await firebase.firestore().collection("users").where("username", "==", username).get()
            if (!targetDoc.empty) {
                userRef = targetDoc.docs[0].ref.id;
                const userDocument = firebase.firestore().collection('users').doc(this.uid)
                const targetUserActivity = firebase.firestore().collection('users').doc(userRef).collection('activity')
                const targetUserStatistics = firebase.firestore().collection('users').doc(userRef).collection('statistics').doc("statistics")
                const userActivity = firebase.firestore().collection('users').doc(this.uid).collection('activity')
                var batch = firebase.firestore().batch();
                batch.set(targetUserStatistics, { referralCount: this.incrementValue(), referralCoinsTotal: this.incrementValue(REWARD_LINK_USED) }, { merge: true })
                batch.set(targetUserActivity.doc(),
                    {
                        timestamp: this.timestamp,
                        //text: message, 
                        state: "pending",
                        type: "referral_used",
                        uid: this.uid,
                        coins: REWARD_LINK_USED,
                    })
                batch.set(userActivity.doc(),
                    {
                        timestamp: this.timestamp,
                        //text: message, 
                        state: "pending",
                        type: "referral_reward",
                        uid: userRef,
                        coins: REWARD_LINK,
                    })

                batch.update(userDocument, { referralUser: userRef, })

                await batch.commit()
                this.currentUser.referralUser = userRef
                return userRef
            } else {
                return 2
            }
        } catch (error) {
            Aux.handleError(error)
            return 3
        }
    }

    LikePostAdmin = async(post) => {
        try {
            const postDocument = firebase.firestore().collection("posts").doc(post.id);

            const targetUserDoc = firebase.firestore().collection("users").doc(post.uid)
            const targetUserDocStatistics = targetUserDoc.collection("statistics").doc("statistics")
            const targetUserDocActivity = targetUserDoc.collection("activity").doc(post.id)
            var batch = firebase.firestore().batch();

            batch.set(targetUserDocActivity, { 
                postid: post.id, 
                uid: this.uid, 
                timestamp: this.timestamp, 
                likesCount: this.incrementValue(), 
                type: "like", 
                text: post.text, 
                image: post.image }, { merge: true })
            if(post.ranking + 1 >= LIMIT_TRENDING_REWARD){
                batch.update(postDocument, { 
                    likesCount: this.incrementValue(), 
                    trendingRanking: this.incrementValue(1),
                    ranking: this.incrementValue(1) })
            }else{
                batch.update(postDocument, { 
                    likesCount: this.incrementValue(), 
                    ranking: this.incrementValue(1) })
            }
            
            batch.set(targetUserDocStatistics, { 
                likesCount: this.incrementValue(),
                likesToEarn: this.incrementValue(), }, { merge: true })

            await batch.commit();
        } catch (error) {
            Aux.handleError(error)
        }
    }

    toogleLikePost = async (post) => {
        try {
            const userDocument = firebase.firestore().collection('users').doc(this.uid);
            const postDocument = firebase.firestore().collection("posts").doc(post.id);
            const likesDocument = userDocument.collection("likes");
            const targetUserDoc = firebase.firestore().collection("users").doc(post.uid)
            const targetUserDocStatistics = targetUserDoc.collection("statistics").doc("statistics")
            const targetUserDocActivity = targetUserDoc.collection("activity").doc(post.id)
            var batch = firebase.firestore().batch();
            if (post.liked) {
                if(post.ranking - 1 >= LIMIT_TRENDING_REWARD){
                    batch.update(postDocument, { 
                        likesCount: this.decrementValue(), 
                        trendingRanking: this.decrementValue(1),
                        ranking: this.decrementValue(1) })
                }else{
                    batch.update(postDocument, { 
                        likesCount: this.decrementValue(), 
                        ranking: this.decrementValue(1) })
                }
                batch.set(targetUserDocStatistics, { 
                    likesCount: this.decrementValue(),
                    likesToEarn: this.decrementValue() }, { merge: true })
                await likesDocument.where("postid", "==", post.id).get().then((data) => {
                    data.docs.map(doc => {
                        batch.delete(doc.ref);
                        return doc
                    });
                })
            } else {
                batch.set(targetUserDocActivity, { 
                    postid: post.id, 
                    uid: this.uid, 
                    timestamp: this.timestamp, 
                    likesCount: this.incrementValue(), 
                    type: "like", 
                    text: post.text, 
                    image: post.image }, { merge: true })
                if(post.ranking + 1 >= LIMIT_TRENDING_REWARD){
                    batch.update(postDocument, { 
                        likesCount: this.incrementValue(), 
                        trendingRanking: this.incrementValue(1),
                        ranking: this.incrementValue(1) })
                }else{
                    batch.update(postDocument, { 
                        likesCount: this.incrementValue(), 
                        ranking: this.incrementValue(1) })
                }
                batch.set(likesDocument.doc(), { 
                    uid: this.uid, 
                    postid: post.id, 
                    text: post.text, 
                    image: post.image, 
                    timestamp: this.timestamp })
                batch.set(targetUserDocStatistics, { 
                    likesCount: this.incrementValue(),
                    likesToEarn: this.incrementValue(), }, { merge: true })
            }

            await batch.commit();
        } catch (error) {
            Aux.handleError(error)
        }

    }

    addPromoCode = async (code, reward) => {
        if(!this.uid || !code || !reward)
            return;

        try {
            const result = await firebase.firestore().collection("users").doc(this.uid)
                .collection("statistics").where("codes", "array-contains", code).get()

            if (result.empty) {
                await firebase.firestore().collection("users").doc(this.uid).collection("statistics")
                    .doc("promoCodes").set({ "codes": firebase.firestore.FieldValue.arrayUnion(code) }, { merge: true })
                await this.SendSystemMessage("Congratulations! You've used the code: " + code, reward)
                return 1
            } else {
                return 2
            }

        } catch (error) {
            Aux.handleError(error)
            return 3
        }
    }

    CheckIfUsernameExists = async (username) => {
        const query = await firebase.firestore().collection("users").where("username", "==", username.toLowerCase()).get();
        if (query.empty) {
            return true;
        } else {
            return false;
        }
    }

    sendReport = async (postId) => {
        try {
            let db = firebase.firestore().collection("reports").doc()
            await db.set({
                postId: postId,
                uid: this.uid,
                timestamp: this.timestamp,
            })
        } catch (error) {
            Aux.handleError(error)
        }
    }

    sendContactMessage = async (email, title, message) => {
        try {
            let db = firebase.firestore().collection("Contact_Messages").doc()
            await db.set({
                email: email,
                uid: this.uid || "",
                timestamp: this.timestamp,
                title: title,
                message: message,
            })
        } catch (error) {
            Aux.handleError(error)
        }
    }

    SendSystemMessage = async (message, coins) => {
        if (!message || !coins)
            return
        const userDocument = firebase.firestore().collection('users').doc(this.uid).collection('activity')
        var batch = firebase.firestore().batch();
        try {
            batch.set(userDocument.doc(),
                {
                    timestamp: this.timestamp,
                    text: message,
                    state: "pending",
                    type: "system_message",
                    uid: this.uid,
                    coins: coins,
                })
            await batch.commit()
        } catch (error) {
            Aux.handleError(error)
        }

    }

    CreateShortLink = async (uid) => {
        if (!uid) {
            return null
        }
        try {
            let myBody = {
                "dynamicLinkInfo": {
                    "link": "https://richless.app/invitation?uid=" + uid,
                    "domainUriPrefix": 'https://richless.page.link',
                    "androidInfo": {
                        "androidPackageName": "com.godapp.richless.app",
                    },
                    "socialMetaTagInfo": {
                        "socialTitle": "Install Richless and get 10$",

                        //descriptionText:"Install the app and get 20$"
                    }
                },
                "suffix": {
                    "option": "SHORT"
                }

            }
            //TODO
            const api_key = "AIzaSyDMLTIvDE4nt69tdlK-vd_QXqhOdUq7lYY"
            const response = await fetch("https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=" + api_key, {
                method: 'Post',
                headers: { 'Content-type': 'application/json' },
                body: JSON.stringify(myBody)
            })
            const data = await response.json()
            if (data) {
                if (data.shortLink) {
                    var linkId = data.shortLink.split("/").pop()
                    return linkId
                }

                else
                    return null
            } else {
                return null
            }
        } catch (error) {
            Aux.handleError(error)
            return null
        }
    }

    getHashtags = async (lastVisible, limit) => {
        try {
            let initialQuery = firebase.firestore().collection('hashtags').orderBy('coins', 'desc').limit(limit)

            if (lastVisible) {
                initialQuery = initialQuery.startAfter(lastVisible);
            }

            let snapshot = await initialQuery.get();

            if (!snapshot.empty) {
                return snapshot;
            } else {
                return null
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    GetPostsData = async (type, lastVisible, limit, userId, hashtag) => {
        try {
            let initialQuery = firebase.firestore().collection('posts').orderBy('coins', 'desc').limit(10)

            switch (type) {
                case "latest":
                    initialQuery = firebase.firestore().collection('posts')
                        .orderBy('timestamp', 'desc')
                        .limit(limit)
                    break;
                case "top":
                    initialQuery = firebase.firestore().collection('posts')
                        .orderBy('coins', 'desc')
                        .limit(limit)
                    break;
                case "trending":
                    initialQuery = firebase.firestore().collection('posts')
                    
                    .limit(limit)
                    if(hashtag){
                        initialQuery = initialQuery.orderBy('ranking', 'desc')
                    }else{
                        initialQuery = initialQuery.orderBy('timeSince', 'desc')
                        .orderBy('trendingRanking', 'desc')
                    }
                    

                    /*  const _1daysago = Date.now() - (2 * 24 * 60 * 60 * 1000);
                        const daysago = new Date(_1daysago)
                        const now = firebase.firestore.Timestamp.fromDate(new Date(Date.now()));
                        const after = firebase.firestore.Timestamp.fromDate(daysago); 
                    initialQuery = firebase.firestore().collection('posts')
                        .orderBy('ranking', 'desc')
                        .orderBy('timestamp', 'desc')*/
                        //.orderBy('timestamp', 'desc')
                        //.where('timestamp', '>=', after)
                        //.where('ranking', '>=', 0)
                        /* .startAt(now)
                        .endAt(after) */
                        
                    break;
                case "userPosts":
                    initialQuery = firebase.firestore().collection('posts')
                        .where("username", "==", userId.toLowerCase())
                        .limit(limit)
                    break;
                case "myPosts":
                    initialQuery = firebase.firestore().collection('posts')
                        .where("uid", "==", this.uid)
                        .limit(limit)
                    break;
                case "myLikes":
                    initialQuery = firebase.firestore().collection('users')
                        .doc(this.uid)
                        .collection('likes')
                        .orderBy('timestamp', 'desc')
                        .limit(limit)
                    break;
                case "myComments":
                    initialQuery = firebase.firestore().collection('comments')
                        .where("uid", "==", this.uid)
                        .limit(limit)
                    break;
                case "postComments":
                    initialQuery = firebase.firestore().collection('comments')
                        .where("postid", "==", userId)
                        .orderBy("coins")
                        .limit(limit)
                    break;
                case "topUsers":
                    initialQuery = firebase.firestore().collection('users')
                        .orderBy("coinsSpent", "desc")
                        .limit(limit)
                    break;
                case "hashtags":
                    initialQuery = firebase.firestore().collection('hashtags')
                        .orderBy('coins', 'desc')
                        .limit(limit)
                    break;
                case "dummyUsers":
                    initialQuery = firebase.firestore().collection('users')
                        .where("role", "==", "dummy")
                        .orderBy("timestamp", "desc")
                        .limit(limit)
                    break;
                default:

                    break;
            }
            if (lastVisible) {
                initialQuery = initialQuery.startAfter(lastVisible);
            }

            if (hashtag) {
                initialQuery = initialQuery.where("hashtag", "==", hashtag)
            }

            let snapshot = await initialQuery.get();

            if (!snapshot.empty) {
                return snapshot;
            }
        } catch (error) {
            Aux.handleError(error)
        }

    }

    getUserInfo = async (uid) => {
        try {
            const userQuery = await firebase.firestore().collection("users").doc(uid).get();
            if (userQuery.exists) {
                return userQuery.data();
            } else {
                return false;
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getUserInfoUid = async (uid) => {
        try {
            const userQuery = await firebase.firestore().collection("users").doc(uid).get();
            if (userQuery.exists) {
                return userQuery.data();
            } else {
                return false;
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getUserInfoUsername = async (username, isId) => {
        try {
            let newUser = {}
            if (isId) {
                const userQuery = await firebase.firestore().collection("users").doc(username).get();
                if (!userQuery.empty) {
                    newUser = userQuery.data()
                    newUser.uid = userQuery.id
                    return newUser
                } else {
                    return false;
                }
            } else {
                const userQuery = await firebase.firestore().collection("users").where("username", "==", username.toLowerCase()).get();
                if (!userQuery.empty) {
                    newUser = userQuery.docs[0].data();
                    newUser.uid = userQuery.docs[0].id
                    return newUser
                } else {
                    return false;
                }
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    setNewLastNotification = async (lastNotificationId) => {
        try {
            firebase.firestore().collection("users").doc(this.uid).update({ lastNotification: lastNotificationId })
        } catch (error) {
            Aux.handleError(error)
        }

    }

    getSearchHashtag = async (searchText, limit) => {
        try {
            let initialQuery = firebase.firestore()
                .collection('hashtags')
                .orderBy('hashtag')
                .startAt(searchText)
                .endAt(searchText + '\uf8ff')
                .limit(limit || 20)

            let snapshot = await initialQuery.get();

            if (!snapshot.empty) {
                let data = snapshot.docs.map(document => {
                    const doc = document.data();
                    doc.id = document.id;
                    return doc;
                });
                return data;
            } else {
                return false

            }
        } catch (error) {
            Aux.handleError(error)
            return false
        }
    }

    getSearchUser = async (searchText, limit) => {
        try {
            let initialQuery = firebase.firestore()
                .collection('users')
                .orderBy('username')
                .startAt(searchText)
                .endAt(searchText + '\uf8ff')
                .limit(limit)

            let snapshot = await initialQuery.get();

            if (!snapshot.empty) {
                let data = snapshot.docs.map(document => {
                    const doc = document.data();
                    doc.id = document.id;
                    return doc;
                });
                return data;
            } else {
                return false

            }
        } catch (error) {
            Aux.handleError(error);
            return false
        }
    }

    //#region messageRequests

    GetAllMessagesFromChat = async (chat, lastVisible, limit) => {
        try {
            let initialQuery = firebase.firestore().collection('chats')
                .doc(chat)
                .collection("messages")
                .orderBy('timestamp', 'asc')
                .limit(limit)
            if (lastVisible) {
                initialQuery = initialQuery.startAfter(lastVisible);
            }

            let snapshot = await initialQuery.get();
            if (!snapshot.empty) {
                return snapshot;
            } else {
                return false
            }
        } catch (error) {
            Aux.handleError(error)
            return false;
        }

    }

    GetMyRequestsData = async (lastVisible, limit) => {
        if (!this.uid)
            return;
        try {
            let initialQuery = firebase.firestore().collection('users').doc(this.uid).collection("requests")
                .orderBy('coins', 'desc').orderBy("timestamp", "desc")
                .limit(limit)
            if (lastVisible) {
                initialQuery = initialQuery.startAfter(lastVisible);
            }

            let snapshot = await initialQuery.get();
            if (!snapshot.empty) {
                return snapshot;
            } else {
                return false
            }
        } catch (error) {
            Aux.handleError(error)
            return false;
        }

    }

    GetMyMessagesData = async (lastVisible, limit) => {

        if (!this.uid)
            return;
        try {
            let initialQuery = firebase.firestore().collection('chats')
                .where("users", "array-contains", this.uid).limit(limit)

            if (lastVisible) {
                initialQuery = initialQuery.startAfter(lastVisible);
            }

            let snapshot = await initialQuery.get();
            if (!snapshot.empty) {
                return snapshot;
            } else {
                return false
            }
        } catch (error) {
            Aux.handleError(error)
            return false;
        }

    }

    refuseRequest = async (activityId) => {
        try {
            /* const targetUserDocument = firebase.firestore().collection("users").doc(this.uid);
            const deleteDocument = targetUserDocument.collection("requests").doc(id)
            var batch = firebase.firestore().batch();            
            batch.delete(deleteDocument) */
            
            const userDocument = firebase.firestore().collection('users').doc(this.uid);
            //const targetUserDocument = firebase.firestore().collection("users").doc(target);
            const activitiesDoc = userDocument.collection('activity').doc(activityId)
            var batch = firebase.firestore().batch(); 
            batch.update(activitiesDoc, {
                state: "refused"
            })
            await batch.commit()
            return true
        } catch (error) {
            Aux.handleError(error)
            return false
        }
    }

    acceptRequestAndCreateChat = async (activityId, target, text, coins) => {
        try {
            const userDocument = firebase.firestore().collection("users").doc(this.uid);
            const targetUserDocument = firebase.firestore().collection("users").doc(target);
            const addChatDocument = firebase.firestore().collection('chats').doc()
            const activitiesDoc = userDocument.collection('activity').doc(activityId)
            const targetUserDocActivity = targetUserDocument.collection("activity")
            // const targetUserDocStatistics = targetUserDocument.collection("statistics").doc("statistics")

            var batch = firebase.firestore().batch();
            batch.update(activitiesDoc, {
                state: "accepted"
            })

            batch.set(targetUserDocActivity.doc(), { 
                uid: this.uid,
                requestSentBy: this.uid, 
                timestamp: this.timestamp, 
                type: "accepted_request", 
            })

            batch.set(addChatDocument, {
                from: target,
                /* to: this.uid, */
                coins: coins || 0,
                timestamp: this.timestamp,
                lastMessage: {
                    text: text? text : "Chat created",
                    timestamp: this.timestamp,
                    read:false,
                    from:target,
                },
                users: [
                    target,
                    this.uid,
                ]
            })
            if(coins){
                batch.set(addChatDocument.collection("messages").doc(), {
                    timestamp: this.timestamp,
                    text: "Chat created",
                    system: true,
                })
                batch.set(addChatDocument.collection("messages").doc(), {
                    timestamp: this.timestamp,
                    text: text,
                    coins: coins,
                    from: target,
                })
            }else{
                batch.set(addChatDocument.collection("messages").doc(), {
                    timestamp: this.timestamp,
                    text: "Chat created",
                    system: true,
                })
            }
            //batch.delete(deleteDocument)
            await batch.commit()
            return true;
        } catch (error) {
            Aux.handleError(error)
            return false;
        }
    }

    /* acceptRequestAndCreateChat = async (id, target, username) => {
        try {
            const userDocument = firebase.firestore().collection("users").doc(this.uid);
            const deleteDocument = userDocument.collection("requests").doc(id)
            const addChatDocument = firebase.firestore().collection('chats').doc()

            var batch = firebase.firestore().batch();

            batch.set(addChatDocument, {
                from: target,
                to: this.uid,
                name: username || "",
                timestamp: this.timestamp,
                lastMessage: {
                    text: "Chat created",
                    timestamp: this.timestamp,
                },
                users: [
                    target,
                    this.uid,
                ]
            })
            batch.set(addChatDocument.collection("messages").doc(), {
                timestamp: this.timestamp,
                text: "Chat created",
                system: true,
            })
            batch.delete(deleteDocument)

            await batch.commit()
            return true;
        } catch (error) {
            Aux.handleError(error)
            return false;
        }
    } */

    sendSingleMessage = async (chat, text, uid) => {
        try {
            const chatDocument = firebase.firestore().collection("chats").doc(chat);
            const messagesDocument = chatDocument.collection("messages").doc()
            var batch = firebase.firestore().batch();

            batch.set(messagesDocument, {
                from: uid ? uid : this.uid,
                timestamp: this.timestamp,
                text: text,
            })
            batch.set(chatDocument,
                {
                    lastMessage: {
                        text: text,
                        timestamp: this.timestamp,
                        from: uid ? uid : this.uid,
                        read: false,
                    }
                }, { merge: true })
            await batch.commit()
            return true;
        } catch (error) {
            Aux.handleError(error)
            return false
        }
    }

    sendRequest = async (target, hasMessage, text, coins) => {
        try {
            const targetUserDocument = firebase.firestore().collection("users").doc(target);
            const requestDocument = targetUserDocument.collection("requests")
            const targetUserStatistics = targetUserDocument.collection("statistics").doc("statistics")

            const userDocument = firebase.firestore().collection('users').doc(this.uid)
            const balanceDocument = userDocument.collection('balance').doc();
            var batch = firebase.firestore().batch();

            const query = await requestDocument.where("from", "==", this.uid).get();
            if (!query.empty) {
                return 2;
            }

            if (hasMessage) {
                batch.set(requestDocument.doc(), {
                    from: this.uid,
                    timestamp: this.timestamp,
                    text: text,
                    state: "pending",
                    //type: "message",
                    coins: coins,
                })
                batch.update(userDocument, {
                    coinsSpent: this.incrementValue(coins),
                    coins: this.decrementValue(coins)
                })
                batch.set(balanceDocument, {
                    type: TYPE_SEND_REQUEST_MESSAGE,
                    amount: coins,
                    timestamp: this.timestamp,
                    target: target,
                })

            } else {
                batch.set(requestDocument.doc(), {
                    from: this.uid,
                    timestamp: this.timestamp,
                    coins: 0,
                })
            }

            batch.set(targetUserStatistics, {
                requests: this.incrementValue(),
            }, { merge: true })

            await batch.commit()
            return 1;
        } catch (error) {
            Aux.handleError(error)
            return 3
        }
    }

    createNotificationRequest = async (target, hasMessage, message, coins,) => {
        if (!target)
            return

        const userDocument = firebase.firestore().collection('users').doc(this.uid)
        const balanceDocument = userDocument.collection('balance').doc();
        const userStatistics = userDocument.collection("statistics").doc("statistics")
        //const targetUserDoc = firestore().collection('users').doc(targetUid).collection('activity')
        const targetUserDoc = firebase.firestore().collection("users").doc(target);
        const targetUserDocActivity = targetUserDoc.collection("activity")
        const targetUserDocStatistics = targetUserDoc.collection("statistics").doc("statistics")
        var batch = firebase.firestore().batch();

        const query = await targetUserDocActivity.where("requestSentBy", "==", this.uid).get();
        if (!query.empty) {
            return 2;
        }

        try {
            if (hasMessage) {
                batch.set(targetUserDocActivity.doc(),
                    {
                        timestamp: this.timestamp,
                        text: message,
                        state: "pending",
                        type: "request_message",
                        requestSentBy: this.uid,
                        coins: coins,
                    })
                batch.set(userStatistics, {
                    requestSent: this.incrementValue(),
                    requestsSpent: this.incrementValue(coins)
                }, { merge: true })
                batch.set(targetUserDocStatistics, {
                    requestsCount: this.incrementValue(),
                    requestsCoinsTotal: this.incrementValue(coins)
                }, { merge: true })
                batch.update(userDocument, {
                    coinsSpent: this.incrementValue(coins),
                    coins: this.decrementValue(coins)
                })
                batch.set(balanceDocument, {
                    type: TYPE_SEND_REQUEST_MESSAGE,
                    amount: coins,
                    timestamp: this.timestamp,
                    senderuid: target,
                })
            }else {
                batch.set(targetUserDocActivity.doc(),
                {
                    timestamp: this.timestamp,
                    state: "pending",
                    type: "request",
                    requestSentBy: this.uid,
                    coins: 0,
                })
                batch.set(userStatistics, {
                    requestSent: this.incrementValue(),
                }, { merge: true })
                batch.set(targetUserDocStatistics, {
                    requestsCount: this.incrementValue(),
                }, { merge: true })
            }
            await batch.commit()
            return 1;
        } catch (error) {
            Aux.handleError(error)
            return 3
        }
    }

    createMessage = async (message, coins, targetUid,) => {
        if (!message || !coins || !targetUid)
            return

        const userDocument = firebase.firestore().collection('users').doc(this.uid)
        const balanceDocument = userDocument.collection('balance').doc();
        const userStatistics = userDocument.collection("statistics").doc("statistics")
        //const targetUserDoc = firestore().collection('users').doc(targetUid).collection('activity')
        const targetUserDoc = firebase.firestore().collection("users").doc(targetUid);
        const targetUserDocActivity = targetUserDoc.collection("activity")
        const targetUserDocStatistics = targetUserDoc.collection("statistics").doc("statistics")
        var batch = firebase.firestore().batch();
        try {
            batch.set(targetUserDocActivity.doc(),
                {
                    timestamp: this.timestamp,
                    text: message,
                    state: "pending",
                    type: "message",
                    uid: this.uid,
                    coins: coins,
                })
            batch.set(userStatistics, {
                messagesSent: this.incrementValue(),
                messagesSpent: this.incrementValue(coins)
            }, { merge: true })
            batch.set(targetUserDocStatistics, {
                messagesCount: this.incrementValue(),
                messagesCoinsTotal: this.incrementValue(coins)
            }, { merge: true })
            batch.update(userDocument,
                {
                    coinsSpent: this.incrementValue(coins),
                    coins: this.decrementValue(coins)
                })
            batch.set(balanceDocument, {
                type: TYPE_MESSAGE_SENT,
                amount: coins,
                timestamp: this.timestamp,
                senderuid: targetUid,
            })
            await batch.commit()
            return true;
        } catch (error) {
            Aux.handleError(error)
            return false
        }
    }

    //#endregion

    //#region collectables

    uploadCollectable = async (uri, coins, title, description, category, hide,) => {
        var imageURL = null;
        try {
            //this.checkIfCoins()

            if (uri) {
                let storageRef = firebase.storage().ref(`collectables/`).child(uuidv4());
                await storageRef.put(uri).then(async () => {
                    await storageRef.getDownloadURL().then((downloadURL) => {
                        imageURL = downloadURL
                    })
                })
            }
            const userDocument = firebase.firestore().collection("users").doc(this.uid);
            const collectableDocument = firebase.firestore().collection("collectables").doc();
            const balanceDocument = userDocument.collection("balance").doc();
            var batch = firebase.firestore().batch();
            batch.set(collectableDocument, {
                image: imageURL,
                coins: coins,
                startCoins: coins,
                title: title,
                description: description,
                timestamp: this.timestamp,
                uid: this.uid,
                ranking: 0,
                category: category,
                hide: hide,
            })

            batch.update(userDocument, {
                coinsSpent: this.incrementValue(coins),
                coins: this.decrementValue(coins),
                postsCount: this.incrementValue(1),
            })



            batch.set(balanceDocument, {
                type: TYPE_ADD_COLLECTABLE,
                amount: coins,
                timestamp: this.timestamp,
            })
            await batch.commit()
            return true;
        } catch (error) {
            Aux.handleError(error)
            return false;
        }
    }

    buyCollectable = async (id, coins,) => {
        try {
            const userDocument = firebase.firestore().collection("users").doc(this.uid);
            const collectableDocument = firebase.firestore().collection("collectables").doc(id);
            const newOwnerDocument = collectableDocument.collection("Owners").doc()
            const balanceDocument = userDocument.collection("balance").doc();
            var batch = firebase.firestore().batch();
            batch.set(newOwnerDocument, {
                uid: this.uid,
                coins: coins,
                timestamp: this.timestamp
            })

            batch.update(userDocument, {
                coinsSpent: this.incrementValue(coins),
                coins: this.decrementValue(coins),
                postsCount: this.incrementValue(1),
            })

            batch.set(balanceDocument, {
                type: TYPE_ADD_COLLECTABLE,
                amount: coins,
                timestamp: this.timestamp,
            })

            await batch.commit()
            return true;
        } catch (error) {
            Aux.handleError(error)

        }
    }

    getCollectableInfo = async (id) => {
        try {
            const collectableQuery = await firebase.firestore().collection("collectables").doc(id).get();
            if (collectableQuery.exists) {
                return collectableQuery.data();
            } else {
                return false;
            }
        } catch (error) {
            Aux.handleError(error)
            return false
        }
    }

    GetCollectablesData = async (type, lastVisible, limit, userId, category) => {
        try {
            let initialQuery = firebase.firestore().collection('collectables').orderBy('coins', 'desc').limit(10)

            switch (type) {
                case "latest":
                    initialQuery = firebase.firestore().collection('collectables')
                        .orderBy('timestamp', 'desc')
                        .limit(limit)
                    break;
                case "top":
                    initialQuery = firebase.firestore().collection('collectables')
                        .orderBy('coins', 'desc')
                        .limit(limit)
                    break;
                case "trending":
                    initialQuery = firebase.firestore().collection('collectables')
                        .orderBy('ranking', 'desc')
                        .limit(limit)
                    break;
                case "userPosts":
                    initialQuery = firebase.firestore().collection('collectables')
                        .where("username", "==", userId.toLowerCase())
                        .limit(limit)
                    break;
                case "myPosts":
                    initialQuery = firebase.firestore().collection('collectables')
                        .where("uid", "==", this.uid)
                        .limit(limit)
                    break;
                default:

                    break;
            }
            if (lastVisible) {
                initialQuery = initialQuery.startAfter(lastVisible);
            }

            if (category) {
                initialQuery = initialQuery.where("category", "==", category)
            }

            let snapshot = await initialQuery.get();
            if (!snapshot.empty) {
                return snapshot;
            } else {
                return false
            }
        } catch (error) {
            Aux.handleError(error)
            return false;
        }

    }

    //#endregion

    //#region post

    uploadPost = async (user, text, uri, coins, hashtag, hide, website, daysSince) => {
        var imageURL = null;
        try {
            //this.checkIfCoins()

            if (uri) {
                let storageRef = firebase.storage().ref(`posts/`).child(uuidv4());
                await storageRef.put(uri).then(async () => {
                    await storageRef.getDownloadURL().then((downloadURL) => {
                        imageURL = downloadURL
                    })
                })
            }
            const userDocument = firebase.firestore().collection("users").doc(this.uid);
            const postDocument = firebase.firestore().collection("posts").doc();
            const balanceDocument = userDocument.collection("balance").doc();
            let hashtagDocument = null
            if (hashtag) {
                hashtagDocument = firebase.firestore().collection("hashtags").doc(hashtag)
            }
            var batch = firebase.firestore().batch();
            batch.set(postDocument, {
                text: text,
                image: imageURL,
                coins: coins,
                startCoins: coins,
                timestamp: this.timestamp,
                avatar: user.avatar,
                //name: this.currentUser.name,
                username: user.username,
                uid: this.uid,
                hashtag: hashtag,
                ranking: 0,
                timeSince: daysSince || 0, 
                hide: hide,
                website: website,
            })

            batch.update(userDocument, {
                coinsSpent: this.incrementValue(coins),
                coins: this.decrementValue(coins),
                postsCount: this.incrementValue(1),
            })



            batch.set(balanceDocument, {
                type: TYPE_CREATE_POST,
                amount: coins,
                timestamp: this.timestamp,
            })

            if (hashtag) {
                batch.set(hashtagDocument, {
                    hashtag: hashtag,
                    coins: this.incrementValue(coins),
                    postsCount: this.incrementValue(1),
                }, { merge: true })
            }
            await batch.commit()
            return true;
        } catch (error) {
            Aux.handleError(error)
            return false;
        }
    }

    updatePost = async (post, text, uri, hide, website, deleteImage, deleteWebsite) => {
        var newPost = post;
        try {
            const postDocument = firebase.firestore().collection("posts").doc(post.id);
            var batch = firebase.firestore().batch();
            if (uri && !deleteImage) {
                let storageRef = firebase.storage().ref(`posts/`).child(uuidv4());
                await storageRef.put(uri).then(async () => {
                    await storageRef.getDownloadURL().then((downloadURL) => {
                        newPost.image = downloadURL
                    })
                })
            }
            if (text && post.text !== text) {
                newPost.text = text;
            }
            if (deleteImage) {
                newPost.image = null;
            }
            if (post.hide !== hide) {
                newPost.hide = hide
            }
            if (deleteWebsite) {
                newPost.website = null
            } else if (website && post.website !== website) {
                newPost.website = website
            }

            batch.update(postDocument, {
                text: newPost.text || "",
                image: newPost.image || null,
                hide: newPost.hide || false,
                website: newPost.website || null,
            })
            await batch.commit()
            return true;
        } catch (error) {
            Aux.handleError(error)
            return false
        }
    }

    deletePost = async (uid) => {
        try {
           await firebase.firestore().collection("posts").doc(uid).delete()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    uploadProfilePhotoAsync = async (uri, filename, size) => {
        return new Promise(async (res, rej) => {
            let storageRef = firebase.storage().ref(filename);

            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 500,
                useWebWorker: true
            }
            await imageCompression(uri, options).then(resizeImage => {
                storageRef.put(resizeImage)
                    .on(
                        firebase.storage.TaskEvent.STATE_CHANGED,
                        snapshot => {
                            /* if (snapshot.state === firebase.storage.TaskState.SUCCESS) {
                            
                            } */
                        }
                        , error => {
                            // unsubscribe();
                            rej(error)
                        }, () => {
                            storageRef.getDownloadURL()
                                .then((downloadURL) => {
                                    res(downloadURL);
                                })
                        }
                    )
            })
        });
    }

    addNewComment = async ({ post, text, coins }) => {
        if ( !post || !coins)
            return

        try {
            const postDocument = firebase.firestore().collection('posts').doc(post.id)
            const commentDocument = firebase.firestore().collection('comments');
            const userDocument = firebase.firestore().collection('users').doc(this.uid)
            const balanceDocument = userDocument.collection("balance").doc();
            const targetUserDoc = firebase.firestore().collection("users").doc(post.uid);
            const targetUserDocActivity = targetUserDoc.collection("activity")
            const targetUserDocStatistics = targetUserDoc.collection("statistics").doc("statistics")
            var batch = firebase.firestore().batch();

            if(post.ranking + (coins * 2) >= LIMIT_TRENDING_REWARD){
                batch.update(postDocument, { 
                    commentCount: this.incrementValue(), 
                    ranking: this.incrementValue(coins * 2), 
                    trendingRanking: this.incrementValue(coins * 2),
                    coins: this.incrementValue(coins), 
                    commentCoins: this.incrementValue(coins), });
            }else{
                batch.update(postDocument, { 
                    commentCount: this.incrementValue(), 
                    ranking: this.incrementValue(coins * 2), 
                    coins: this.incrementValue(coins), 
                    commentCoins: this.incrementValue(coins), });
            }
            
            batch.set(commentDocument.doc(), { 
                postid: post.id, 
                uid: this.uid, 
                timestamp: this.timestamp, 
                text: text || "", 
                coins: coins })
            batch.set(targetUserDocActivity.doc(), { 
                uid: this.uid, 
                timestamp: this.timestamp, 
                commentText: text || "", 
                type: "comment", 
                postid: post.id, 
                image: post.image, 
                text: post.text,
                coins: coins,
                state:"pending",
                 }, { merge: true })
            batch.set(targetUserDocStatistics, { 
                commentCount: this.incrementValue(), 
                commentCoinsTotal: this.incrementValue(coins) }, { merge: true })
            batch.update(userDocument, {
                coinsSpent: this.incrementValue(coins),
                coins: this.decrementValue(coins),
                //commentsCount: this.incrementValue(),
            })

            batch.set(balanceDocument, {
                type: TYPE_COMMENTED,
                amount: coins,
                timestamp: this.timestamp,
                postid: post.id,
            })
            await batch.commit()
            return true;
        } catch (error) {
            Aux.handleError(error)
            return false;
        }
    }

    getPostInfo = async (id) => {
        try {
            const userQuery = await firebase.firestore().collection("posts").doc(id).get();
            if (userQuery.exists) {
                return userQuery.data();
            } else {
                return false;
            }
        } catch (error) {
            Aux.handleError(error)
            return false
        }
    }

    //#endregion

    //#region user

    CreateUser = async (user, invitationReward) => {
        try {
            await firebase.auth().createUserWithEmailAndPassword(user.email, user.password)

            let db = firebase.firestore().collection("users").doc(this.uid)
            const link = await this.CreateShortLink(this.uid)
            this.currentUser = {
                ...user,
                provider: "email",
                timestamp: this.timestamp,
                coinsSpent: 0,
                linkId: link,
            }
            await db.set({
                email: user.email.toLowerCase(),
                username: user.username.toLowerCase(),
                provider: "email",
                timestamp: this.timestamp,
                linkId: link,
                coins: 0,
                role: "user"
            })
            await db.collection("statistics").doc("statistics").set({})

            if (invitationReward) {
                await this.SendSystemMessage("Welcome to Richless! You've used our code. Here's your reward!", invitationReward)
            } else {
                await this.SendSystemMessage("Welcome to Richless! Here's a reward! Have fun!", 20)
            }
            return true;
        } catch (error) {
            Aux.handleError(error)
            throw error;
        }
    }

    createUserAuth = async (username) => {
        if (!username)
            return;
        if(!this.socialCredentials?.email && !firebase.auth().currentUser?.email){
            return false;
        }
        try {
            const link = await this.CreateShortLink(this.uid);
            this.currentUser = {
                username: username.toLowerCase(),
                email: this.socialCredentials.email || firebase.auth().currentUser?.email || "",
                avatar: this.socialCredentials.photoURL || "",
                name: this.socialCredentials.displayName || "",
                provider: this.socialCredentials.provider || "",
                linkId: link,
                timestamp: this.timestamp,
                coins: 0,
                role: "user",
            }
            let db = firebase.firestore().collection("users").doc(this.uid)
            await db.set(this.currentUser)
            await db.collection("statistics").doc("statistics").set({})
            await this.SendSystemMessage("Welcome to Richless, here's a little gift, spend it wisely!", 20)
            return true;
        } catch (error) {
            Aux.handleError(error)
            return false;
        }
    }

    UpdateUserInfo = async ({ user, username, avatar, name, bio, website, twitter, instagram, snapchat, youtube, facebook, deleteAvatar }) => {
        let remoteUri = null
        var newUser = user;
        const userDoc = firebase.firestore().collection("users").doc(this.uid);
        //const profilePic = firebase.storage().ref("avatars").child(this.uid);
        let updatedPosts = false;
        var batch = firebase.firestore().batch();
        try {
            if (deleteAvatar) {
                batch.update(userDoc, { avatar: null })
                //this.currentUser.avatar = null;
                updatedPosts = true;
            } else if (newUser.avatar !== avatar) {
                remoteUri = await this.uploadProfilePhotoAsync(avatar, `avatars/${this.uid}`, 500)
                //await profilePic.delete();
                batch.update(userDoc, { avatar: remoteUri })
                newUser.avatar = remoteUri;
                updatedPosts = true;
            }
            if (newUser.username !== username && username !== "") {
                batch.update(userDoc, { username: username.toLowerCase() })
                newUser.username = username.toLowerCase();
                updatedPosts = true;
            }
            if (newUser.name !== name) {
                batch.update(userDoc, { name: name })
                newUser.name = name;
            }
            if (newUser.bio !== bio) {
                batch.update(userDoc, { bio: bio })
                newUser.bio = bio;
            }
            if (newUser.website !== website) {
                batch.update(userDoc, { website: website })
                newUser.website = website;
            }

            if (newUser.twitter !== twitter) {
                batch.update(userDoc, { twitter: twitter })
                newUser.twitter = twitter;
            }
            if (newUser.instagram !== instagram) {
                batch.update(userDoc, { instagram: instagram })
                newUser.instagram = instagram;
            }
            if (newUser.snapchat !== snapchat) {
                batch.update(userDoc, { snapchat: snapchat })
                newUser.snapchat = snapchat;
            }
            if (newUser.youtube !== youtube) {
                batch.update(userDoc, { youtube: youtube })
                newUser.youtube = youtube;
            }
            if (newUser.facebook !== facebook) {
                batch.update(userDoc, { facebook: facebook })
                newUser.facebook = facebook;
            }
            if (updatedPosts) {
                const query = await firebase.firestore().collection("posts").where("uid", "==", this.uid).get();
                query.forEach(doc => {
                    batch.update(doc.ref, {
                        avatar: newUser.avatar,
                        username: newUser.username.toLowerCase(),
                    })
                })
            }
            await batch.commit()
        } catch (error) {
            Aux.handleError(error)
        }
    }

    recoverEmail = async (email) => {
        try {
            await firebase.auth().sendPasswordResetEmail(email)
            return true;
        } catch (error) {
            Aux.handleError(error)
            return false;
        }
    }

    signOutUser = () => {
        try {
            firebase.auth().signOut();
        } catch (error) {
            Aux.handleError(error)
        }
    }

    //#endregion

    //#region admin

    setDummyCurrentUser = (user) => {
        this.currentUser = user;
        this.dummyUid = user.id
    }

    deleteDummyUser = () => {
        this.dummyUid = "";
        return firebase.auth().currentUser.uid
    }

    createDummyUser = async (user) => {
        try {
            if (user.avatar) {
                var remoteUri = await this.uploadProfilePhotoAsync(user.avatar, `avatars/dummy/${user.username}`, 500)
                user.avatar = remoteUri;
            }
            let db = firebase.firestore().collection("users").doc()
            await db.set({
                ...user,
                linkId: "",
                coins: 999,
                role: "dummy",
                provider: "dummy",
                timestamp: this.timestamp,
            })
            await db.collection("statistics").doc("statistics").set({})
        } catch (error) {
            Aux.handleError(error)
        }

    }
    //#endregion
}

Fire.shared = new Fire();
export default Fire;
